import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import WkcSchedulingConfigurationDetail from '@/types/table/wkcSchedulingConfigurationDetail';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface WkcSchedulingConfigurationDetailData extends WkcSchedulingConfigurationDetail {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class WkcSchedulingConfigurationDetailController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<WkcSchedulingConfigurationDetailData>>(API_CONTEXT + '/app/wkcSchedulingConfigurationDetail/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<WkcSchedulingConfigurationDetailData>(API_CONTEXT + '/app/wkcSchedulingConfigurationDetail/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/wkcSchedulingConfigurationDetail/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/wkcSchedulingConfigurationDetail/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/wkcSchedulingConfigurationDetail/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcSchedulingConfigurationDetail/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcSchedulingConfigurationDetail/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcSchedulingConfigurationDetail/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcSchedulingConfigurationDetail/deleteBatch', params, httpOptions);
  }
}
